"use strict";
var $dyn;
(function ($dyn) {
    // Server form telemetry, currently implemented transport is the interaction channel
    var telemetry;
    (function (telemetry) {
        telemetry.enabled = true;
        /** @internal */
        telemetry.pingCount = 0;
        function _addInteractions(interactionQueue) {
            if ($dyn.serverForm && interactionQueue && $dyn.length($dyn.telemetry._eventQueue) > 0) {
                // Make a copy of the queue to send with the interaction
                var interaction = {
                    $type: $dyn.serverForm.InteractionType.eventData,
                    EventData: $dyn.telemetry._eventQueue.slice(),
                };
                interactionQueue.unshift(interaction);
                $dyn.async.pending.increment("queue telemetry interaction");
                $dyn.telemetry.clearEvents();
            }
        }
        telemetry._addInteractions = _addInteractions;
        function flushTelemetryEvents() {
            // Flush existing telemetry event interactions
            if ($dyn.serverForm && $dyn.serverForm.interactionManager && $dyn.serverForm.interactionManager.flushTelemetryEvents) {
                $dyn.serverForm.interactionManager.flushTelemetryEvents();
            }
            else {
                $dyn.log("$dyn.serverForm.interactionManager.flushTelemetryEvents() is undefined.");
            }
        }
        telemetry.flushTelemetryEvents = flushTelemetryEvents;
        function addEventInternal(evt) {
            if ($dyn.serverForm && $dyn.serverForm.interactionManager) {
                $dyn.serverForm.interactionManager.queueTelemetryEvent(evt);
            }
        }
        telemetry.addEventInternal = addEventInternal;
    })(telemetry = $dyn.telemetry || ($dyn.telemetry = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Telemetry.js.map
